import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { FormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { OrderModule } from 'ngx-order-pipe'
import { NgxPaginationModule } from 'ngx-pagination'
import { FilterPipeModule } from 'ngx-filter-pipe'
import { routes } from './electronic-soa.routes'
import { ViewElectronicSOAComponent } from './components/view-soa.component'
import { SubmitElectronicSOAComponent } from './components/soa-form-submission.component'
import { SOAViewEmailComponent } from './components/soa-view-email.component'
import { SOAFormSubmissionGateWay } from './gateways/soa-form-submission-gateways'
import { NetworkSOAFormSubmissionGateway } from './gateways/network-soa-form-submission-gateways'
import { ViewSOAGateWay } from './gateways/view-soa-gateways'
import { NetworkViewSOAGateway } from './gateways/network-view-soa-gateways'
import { SOAFormReturnAgentGateWay } from './gateways/soa-form-return-agent-gateways'
import { NetworkViewSOAFormReturnAgentGateway } from './gateways/network-soa-form-return-agent-gateways'

import { ValidationModule } from '../validations/validation.module'

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { HttpRequestInterceptor } from '../interceptor/http-request-interceptor'

import { ElectronicSOALayoutComponent } from './components/layout/electronic-soa-layout.component'
import { ExcelService } from './excel.service'
import { SOAViewReturnToAgentConfirmationComponent } from './components/soa-view-returntoagent-confirmation'
import { SOAFormSubmissionConfirmationComponent } from './components/soa-form-submission-confirmation'
import { SOAFormEmailLinkAgentSignedComponent } from './components/soa-form-email-link-agent-signed'
import { SOAFormEmailLinkAgentExpiredComponent } from './components/soa-form-email-link-agent-expired'
import { PortalCommonModule } from '../common/portal-common.module'
//import { jqxDateTimeInputComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxdatetimeinput'
import { SharedModule } from '../shared/shared.module'
import { Ng2SearchPipeModule } from '@ngx-maintenance/ng2-search-filter' //importing the module
import { EnrollmentGateway } from '../enrollment/gateways/enrollment-gateway'
import { NetworkEnrollementGateway } from '../enrollment/gateways/network-enrollment-gateway'
import { NetworkTrainingCertificatesGateway } from '../training/gateways/network-training-certificates-gateway'
import { TrainingCertificatesGateway } from '../training/gateways/training-certificates-gateway'
@NgModule({
    declarations: [
        ViewElectronicSOAComponent,
        ElectronicSOALayoutComponent,
        SubmitElectronicSOAComponent,
        SOAViewEmailComponent,
        SOAViewReturnToAgentConfirmationComponent,
        SOAFormSubmissionConfirmationComponent,
        SOAFormEmailLinkAgentSignedComponent,
        SOAFormEmailLinkAgentExpiredComponent
    ],
    imports: [
        FormsModule,
        OrderModule,
        NgxPaginationModule,
        FilterPipeModule,
        ValidationModule,
        CommonModule,
        SharedModule,
        PortalCommonModule,
        Ng2SearchPipeModule,
        RouterModule.forChild(routes)
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
        {
            provide: ViewSOAGateWay,
            useClass: NetworkViewSOAGateway
        },
        { provide: SOAFormSubmissionGateWay, useClass: NetworkSOAFormSubmissionGateway },
        { provide: SOAFormReturnAgentGateWay, useClass: NetworkViewSOAFormReturnAgentGateway },
        { provide: EnrollmentGateway, useClass: NetworkEnrollementGateway },
        { provide: TrainingCertificatesGateway, useClass: NetworkTrainingCertificatesGateway },
        ExcelService,
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class ElectrronicSOAModule {}
